import { render, staticRenderFns } from "./SiteSettingsView.vue?vue&type=template&id=7671f5e0"
import script from "./SiteSettingsView.vue?vue&type=script&lang=js"
export * from "./SiteSettingsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports